module.exports = __webpack_public_path__ + "img/configuration.8deeee6b.svg";